import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportYearlyOccupationTrend = async (urlDataAPI: any) => {
    const { exportType, hubIds, sectorIds, occupationCategoryIds, locations, year, yearlyPercentSentence, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportYearlyOccupationTrend;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
        method,
        { exportType, hubIds, ISICCodes: sectorIds, ISCO2Codes: occupationCategoryIds, locations, fromQuarter: year, exportTitle: yearlyPercentSentence, isEntryLevel },
        {
            responseType: "blob"
        },
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
